<template>
  <div>
    <va-modal
      class="modal activity"
      v-model="modalValue"
      :title="modalTitle"
      max-width="100%"
      noEscDismiss
      noOutsideDismiss
      hideDefaultActions
    >
      <div class="forcewidth-ce">
        <div class="row row-inside">
          <div class="flex md6">
            <va-input
              v-model="entreprise.nom"
              label="Nom"
              placeholder="Nom entreprise"
              :error="errors.nom"
            />
          </div>
          <div class="flex md3">
            <va-input
              v-model="phoneNumber"
              label="Téléphone"
              placeholder="Téléphone"
              v-on:paste="trimOnPaste('telephone')"
              v-on:focus="phoneNumber = removeWhiteSpace(phoneNumber)"
            />
          </div>
          <div class="flex md3">
            <va-input
              v-model="portableNumber"
              label="Portable"
              placeholder="Portable"
              v-on:paste="trimOnPaste('portable')"
              v-on:focus="portableNumber = removeWhiteSpace(portableNumber)"
            />
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md6">
            <va-input
              v-model="entreprise.site_internet"
              label="Site internet"
              placeholder="Site internet"
            />
          </div>
          <div class="flex md6">
            <va-input
              v-model="entreprise.email"
              label="Courriel"
              placeholder="Courriel"
              :error="errors.email"
            />
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md3">
            <va-input
              v-model="inputSiret"
              label="SIRET"
              placeholder="SIRET"
              :error="errors.siret"
              v-on:paste="trimOnPaste('siret')"
              v-on:focus="inputSiret = removeWhiteSpace(inputSiret)"
              v-on:blur="formatSiret()"
            />
          </div>
          <div class="flex md3">
            <va-select
              label="Code APE"
              v-model="selectApe"
              textBy="description"
              :options="apeOptions"
              no-clear
            />
          </div>
          <div class="flex md3">
            <va-select
              label="Forme juridique"
              v-model="selectFJ"
              textBy="description"
              :options="fjOptions"
              no-clear
            />
          </div>
          <div class="flex md3">
            <va-select
              label="CCN"
              v-model="selectCCN"
              textBy="displayName"
              keyBy="idccn"
              :options="ccnOptions"
              no-clear
            />
          </div>
        </div>

        <va-separator />

        <div class="row row-inside">
          <div class="flex md12">
            <h4>Contact</h4>
          </div>
          <div class="flex md3">
            <va-select
              label="Titre"
              v-model="contact.titre"
              :options="titreOptions"
              no-clear
              :error="errors.contactTitre"
            />
          </div>
          <div class="flex md5">
            <va-input
              v-model="contact.nom"
              label="Nom"
              placeholder="Contact inconnu"
              :error="errors.contactNom"
            />
          </div>
          <div class="flex md4">
            <va-input
              v-show="contact.titre !== 'SOCIÉTÉ'"
              :disabled="contact.titre === 'SOCIÉTÉ'"
              v-model="contact.prenom"
              label="Prénom"
              placeholder="-"
            />
          </div>
        </div>
        <div class="row row-inside" v-if="contact.titre === 'SOCIÉTÉ'">
          <div class="flex md3">
            <va-select
              label="Titre contact"
              v-model="contact.titre_societe"
              :options="titreOptionsSociete"
              no-clear
            />
          </div>
          <div class="flex md5">
            <va-input
              v-model="contact.nom_societe"
              label="Nom contact"
              placeholder="Contact inconnu"
              :error="errors.contactNom"
            />
          </div>
          <div class="flex md4">
            <va-input
              v-model="contact.prenom_societe"
              label="Prénom contact"
              placeholder="-"
            />
          </div>
        </div>

        <va-separator />

        <div class="row row-inside">
          <div class="flex md12">
            <h4>Adresse</h4>
          </div>
          <div class="flex md12">
            <va-input
              v-model="adresse.adresse"
              label="Adresse"
              placeholder="Adresse"
              :error="errors.adresse"
            />
          </div>
          <div class="flex md12">
            <va-input
              v-model="adresse.complement"
              label="Adresse suite"
              placeholder="Adresse suite"
            />
          </div>
          <div class="flex md2">
            <va-input
              v-model="adresse.code_postal"
              label="Code Postal"
              placeholder="Code Postal"
              :error="errors.codePostal"
            />
          </div>
          <div class="flex md7">
            <va-input
              v-model="adresse.ville"
              label="Ville"
              placeholder="Ville"
              :error="errors.ville"
            />
          </div>
          <div class="flex md3">
            <va-input
              v-model="adresse.cedex"
              label="Cedex"
              placeholder="Cedex"
            />
          </div>
        </div>
      </div>
      <template v-slot:actions>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <div>
            <va-button
              v-if="isEditMode && entreprise.afpf"
              color="gray"
              flat
              small
              @click="deleteEntreprise"
            >
              Supprimer
            </va-button>
          </div>
          <div>
            <va-button color="gray" flat @click="closeModal">Annuler</va-button>
            <va-button @click="saveEntreprise">{{ okText }}</va-button>
          </div>
        </div>
      </template>
    </va-modal>

    <va-modal
      v-model="showDeleteConfirm"
      title="Suppression d'entreprise"
      okText="Supprimer"
      cancelText="Annuler"
      v-on:ok="confirmDelete"
      v-on:cancel="showDeleteConfirm = false"
      noEscDismiss
      noOutsideDismiss
    >
      <div>
        Voulez-vous supprimer cette entreprise et toutes les données associées ?
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { find } from "lodash";

export default {
  name: "create-entreprise",
  props: ["value", "identreprise"],
  data() {
    return {
      errors: {
        nom: false,
        siret: false,
        email: false,
        contactNom: false,
        contactTitre: false,
        adresse: false,
        codePostal: false,
        ville: false,
      },
      entreprise: {
        identreprise: null,
        nom: null,
        telephone: null,
        portable: null,
        site_internet: null,
        email: null,
        siret: null,
        code_ape: null,
        forme_juridique: null,
        ccn: null,
        idccn: null,
        norelance: false,
        afpf: true,
      },
      contact: {
        titre: null,
        nom: null,
        prenom: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
      },
      adresse: {
        id: null,
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      },
      inputSiret: null,
      phoneNumber: null,
      portableNumber: null,
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      selectApe: { id: 99, description: "-" },
      apeOptions: [
        { id: 0, description: "4723Z" },
        { id: 1, description: "4781Z" },
        { id: 2, description: "4638A" },
        { id: 3, description: "Autre" },
        { id: 4, description: "8559A" },
        { id: 99, description: "-" },
      ],
      selectFJ: { id: 99, description: "-" },
      fjOptions: [
        { id: 1, description: "EURL/SARL" },
        { id: 2, description: "SAS" },
        { id: 3, description: "SA" },
        { id: 4, description: "Entreprise Individuelle" },
        { id: 5, description: "CFA" },
        { id: 99, description: "-" },
      ],
      selectCCN: { idccn: 99, displayName: "-", nom: "-" },
      showDeleteConfirm: false,
    };
  },
  computed: {
    ...mapGetters(["listeCCN"]),
    modalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    okText() {
      return this.isEditMode ? "Sauvegarder" : "Créer";
    },
    isEditMode() {
      return !!(this.identreprise || this.entreprise.identreprise);
    },
    modalTitle() {
      if (this.isEditMode) {
        return this.entreprise.nom
          ? `Entreprise: ${this.entreprise.nom}`
          : "Entreprise";
      }
      return "Créer une entreprise AFPF";
    },
    ccnOptions() {
      if (!this.listeCCN || this.listeCCN.length === 0) {
        return [{ idccn: 99, displayName: "-", nom: "-" }];
      }
      const hasEmpty = this.listeCCN.some((ccn) => ccn.idccn === 99);
      return hasEmpty
        ? this.listeCCN
        : [{ idccn: 99, displayName: "-", nom: "-" }, ...this.listeCCN];
    },
  },
  mounted() {
    this.resetForm();
  },
  watch: {
    value(newValue) {
      if (newValue) {
        if (this.identreprise) {
          this.loadEntreprise(this.identreprise);
        } else {
          this.resetForm();
        }
      }
    },
    identreprise(newValue) {
      if (this.value) {
        if (newValue) {
          this.loadEntreprise(newValue);
        } else {
          this.resetForm();
        }
      }
    },
    selectApe(newAPE) {
      this.entreprise.code_ape = newAPE.id !== 99 ? newAPE.id : null;
    },
    selectFJ(newFJ) {
      this.entreprise.forme_juridique = newFJ.id !== 99 ? newFJ.id : null;
    },
    selectCCN(newCCN) {
      this.entreprise.ccn =
        newCCN.idccn !== 99
          ? { idccn: newCCN.idccn, idcc: newCCN.idcc, nom: newCCN.nom }
          : null;
      this.entreprise.idccn = newCCN.idccn !== 99 ? newCCN.idccn : null;
    },
    inputSiret(newSiret) {
      this.entreprise.siret = this.removeWhiteSpace(newSiret);
    },
    phoneNumber(newNumber) {
      this.entreprise.telephone = this.removeWhiteSpace(newNumber);
    },
    portableNumber(newNumber) {
      this.entreprise.portable = this.removeWhiteSpace(newNumber);
    },
  },
  methods: {
    resetForm() {
      this.errors = {
        nom: false,
        siret: false,
        email: false,
        contactNom: false,
        contactTitre: false,
        adresse: false,
        codePostal: false,
        ville: false,
      };
      this.entreprise = {
        identreprise: null,
        nom: null,
        telephone: null,
        portable: null,
        site_internet: null,
        email: null,
        siret: null,
        code_ape: null,
        forme_juridique: null,
        ccn: null,
        idccn: null,
        norelance: false,
        afpf: true,
      };
      this.contact = {
        idcontact: null,
        titre: null,
        nom: null,
        prenom: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
      };
      this.adresse = {
        id: null,
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      };
      this.inputSiret = null;
      this.phoneNumber = null;
      this.portableNumber = null;
      this.selectApe = { id: 99, description: "-" };
      this.selectFJ = { id: 99, description: "-" };
      this.selectCCN = { idccn: 99, displayName: "-", nom: "-" };
    },
    async loadEntreprise(identreprise) {
      try {
        const res = await axios.get("/api/entreprise-infos", {
          params: { id: identreprise },
        });
        this.resetForm();

        const data = res.data;
        const etablissement = data.etablissement || {};
        const contact = etablissement.contact || {};
        const adresse = etablissement.adress || {};

        this.entreprise = {
          ...this.entreprise,
          ...data,
          identreprise: data.identreprise,
          norelance: data.norelance || false,
          siret: etablissement.siret || data.siret || null,
          telephone: data.telephone || null,
          portable: data.portable || null,
          site_internet: data.site_internet || null,
        };
        this.contact = {
          ...this.contact,
          ...contact,
        };
        this.adresse = {
          ...this.adresse,
          ...adresse,
        };

        this.selectApe =
          data.code_ape || data.code_ape === 0
            ? find(this.apeOptions, ["id", data.code_ape])
            : find(this.apeOptions, ["id", 99]);
        this.selectFJ = data.forme_juridique
          ? find(this.fjOptions, ["id", data.forme_juridique])
          : find(this.fjOptions, ["id", 99]);
        this.selectCCN = data.ccn
          ? find(this.ccnOptions, { idccn: data.idccn })
          : { idccn: 99, nom: "-", displayName: "-" };

        this.inputSiret = this.entreprise.siret ? this.entreprise.siret : null;
        this.formatSiret();
        this.phoneNumber = this.entreprise.telephone
          ? this.entreprise.telephone
          : null;
        this.portableNumber = this.entreprise.portable
          ? this.entreprise.portable
          : null;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de l'entreprise");
      }
    },
    trimOnPaste(entry) {
      if (entry === "siret") {
        setTimeout(() => {
          this.inputSiret = this.removeWhiteSpace(this.inputSiret);
        }, 200);
      }
      if (entry === "telephone") {
        setTimeout(() => {
          this.phoneNumber = this.removeWhiteSpace(this.phoneNumber);
        }, 200);
      }
      if (entry === "portable") {
        setTimeout(() => {
          this.portableNumber = this.removeWhiteSpace(this.portableNumber);
        }, 200);
      }
    },
    formatSiret() {
      if (!this.inputSiret) return;
      const siret = this.removeWhiteSpace(this.inputSiret);
      this.entreprise.siret = siret;
      if (!siret) return;
      this.inputSiret =
        siret.slice(0, 3) +
        " " +
        siret.slice(3, 6) +
        " " +
        siret.slice(6, 9) +
        " " +
        siret.slice(9, 14);
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    isValidSiret() {
      if (!this.entreprise.siret) return false;
      const str = this.entreprise.siret.replace(/^[0]+/g, "");
      return str.length === 14 && !Number.isNaN(Number(str));
    },
    validateForm() {
      this.errors.nom = !this.entreprise.nom;
      this.errors.siret = !this.isValidSiret();
      this.errors.email = !this.entreprise.email;
      this.errors.contactTitre = !this.contact.titre;
      if (this.contact.titre === "SOCIÉTÉ") {
        this.errors.contactNom = !this.contact.nom_societe;
      } else {
        this.errors.contactNom = !this.contact.nom;
      }
      this.errors.adresse = !this.adresse.adresse;
      this.errors.codePostal = !this.adresse.code_postal;
      this.errors.ville = !this.adresse.ville;

      return !(
        this.errors.nom ||
        this.errors.siret ||
        this.errors.email ||
        this.errors.contactTitre ||
        this.errors.contactNom ||
        this.errors.adresse ||
        this.errors.codePostal ||
        this.errors.ville
      );
    },
    async saveEntreprise() {
      if (!this.validateForm()) {
        this.launchEpicmaxToast(
          "Nom, SIRET, courriel, contact et adresse obligatoires"
        );
        return;
      }

      const entrepriseMod = { ...this.entreprise };
      if (this.selectApe.id === 99) {
        entrepriseMod.code_ape = null;
      }
      if (this.selectFJ.id === 99) {
        entrepriseMod.forme_juridique = null;
      }
      if (this.selectCCN.idccn === 99) {
        entrepriseMod.ccn = null;
        entrepriseMod.idccn = null;
      }
      entrepriseMod.afpf = true;

      const contactMod = { ...this.contact };
      if (contactMod.titre === "SOCIÉTÉ") {
        contactMod.prenom = null;
      } else {
        contactMod.titre_societe = null;
        contactMod.nom_societe = null;
        contactMod.prenom_societe = null;
      }

      const adresseMod = { ...this.adresse };

      const isEdit = !!this.identreprise || !!this.entreprise.identreprise;
      if (isEdit) {
        entrepriseMod.identreprise =
          this.identreprise || this.entreprise.identreprise;
      }

      const params = {
        isNew: !isEdit,
        norelance: this.entreprise.norelance || false,
        entrepriseInfosChanged: true,
        contactInfosChanged: true,
        adresseInfosChanged: true,
        entreprise: entrepriseMod,
        contact: contactMod,
        adresse: adresseMod,
        verifierEntreprise: false,
        nb_salaries: null,
        siege_siret: entrepriseMod.siret,
        siegeInfosChanged: true,
        mapaChanged: -1,
      };

      try {
        if (isEdit) {
          const res = await axios.post("/api/update-entreprise-all", params);
          this.launchEpicmaxToast("Entreprise mise à jour");
          this.$emit("update", res.data);
        } else {
          const res = await axios.post("/api/create-new-entreprise", params);
          const newEntreprise = Array.isArray(res.data) ? res.data[0] : res.data;
          this.launchEpicmaxToast("Entreprise créée");
          this.$emit("create", newEntreprise);
        }
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          isEdit
            ? "L'entreprise n'a pas pu être mise à jour"
            : "L'entreprise n'a pas pu être créée"
        );
      }
    },
    async deleteEntreprise() {
      if (!this.isEditMode) return;
      const identreprise = this.identreprise || this.entreprise.identreprise;
      if (!identreprise) return;
      this.showDeleteConfirm = true;
    },
    async confirmDelete() {
      const identreprise = this.identreprise || this.entreprise.identreprise;
      if (!identreprise) return;
      try {
        await axios.delete("/api/entreprise", {
          data: { entreprise: { identreprise } },
        });
        this.launchEpicmaxToast("Entreprise supprimée");
        this.$emit("delete", identreprise);
        this.showDeleteConfirm = false;
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la suppression");
      }
    },
    closeModal() {
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped>
.forcewidth-ce {
  width: 70vw;
  max-height: 85vh;
  overflow: auto;
}
</style>
